export const environment = {
    BASE_WS_URL: 'api/',
    authIssuer: 'https://abaco-kyc.eu.auth0.com/',
    authClientId: 'w8zpyfACnjpflT6rsAWVqtmcH9hPQKI7',
    authRedirectPath: '/oauth2/callback',    
    authScope: 'openid profile email',
};